// Builds a simple immutable entitlement registry from canonical capability definitions.
import type { EntitlementCapabilityDefinition, EntitlementRegistry } from '../core/types';

export function createEntitlementRegistry(definitions: EntitlementCapabilityDefinition[]): EntitlementRegistry {
  const byKey = new Map(definitions.map((definition) => [definition.key, definition]));

  return {
    getCapability(key: string): EntitlementCapabilityDefinition | null {
      return byKey.get(key) ?? null;
    },

    listCapabilities(): EntitlementCapabilityDefinition[] {
      return [...definitions];
    },
  };
}
